<template>
  <div class="container">

    <v-card>
      <v-card-title class="blue accent-1 gray--text">Listado de proveedores</v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="4">
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn
                  color="primary"
                  dark
                  right
                 @click="dialog = !dialog"
                  v-on="on"
                >
                  <v-icon>mdi-plus</v-icon>
                </v-btn>
              </template>
              <span>Agregar nuevo proveedor</span>
            </v-tooltip>
          </v-col>
          <v-col cols="4">
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn
                  color="green"
                  dark
                  right
                 @click="upload = !upload"
                  v-on="on"
                >
                  <v-icon>mdi-file-excel</v-icon>
                </v-btn>
              </template>
              <span>Carga masiva de proveedores</span>
            </v-tooltip>
          </v-col>
          <v-col cols="4">
            <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Escriba para filtrar proveedores"
                single-line
                hide-details
            ></v-text-field>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <v-data-table 
        :headers="companiesListHeaders"
        :items="companiesListBody"
        class="elevation-3 mt-5"
        no-data-text="No hay proveedores"
        :search="search"
    >
      <template v-slot:[`item.actions`]="{item}">
        <v-tooltip left>
          <template v-slot:activator="{ on }">
            <v-icon
              medium
              class="mr-2"
              @click="editCompany(item)"
              v-on="on"
            >
              mdi-pencil
            </v-icon>
          </template>
          <span>Editar Proveedor</span>
        </v-tooltip>
        <v-tooltip left>
          <template v-slot:activator="{ on }">
            <v-icon
                medium
                @click="deleteCompany(item)"
                v-on="on"
            >
            mdi-delete
            </v-icon>
          </template>
          <span>Eliminar Proveedor</span>
        </v-tooltip>
      </template>
    </v-data-table>

    <!-- Modal New -->
    <v-dialog
      v-model="dialog"
      width="800px"
      @click:outside = "closeModal"
    >
      <v-card>
        <v-card-title class="blue darken-1">
          Datos del proveedor
        </v-card-title>
        <v-container>
          <v-row class="mx-2">
            <v-col
              class="align-center justify-space-between"
              cols="6"
            >
              <v-text-field
                prepend-icon="mdi-barcode"
                placeholder="Rut"
                label="Rut"
                v-model="company.rut"
              >
              </v-text-field>
            </v-col>
            <v-col
              class="align-center justify-space-between"
              cols="6"
            >
              <v-text-field
                prepend-icon="mdi-format-text"
                placeholder="Nombre"
                label="Nombre"
                v-model="company.name"
              >
              </v-text-field>
            </v-col>
          </v-row>
        </v-container>
        <v-card-actions>
          <v-btn
            @click="closeModal"
          >Cerrar</v-btn>
          <v-btn
            color="primary"
            @click="saveCompany"
          >Grabar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- / Modal New-->

    <!-- Modal upload -->
    <v-dialog
      v-model="upload"
      width="600px"
    >
      <v-card>
        <v-card-title class="green darken-1">
          Subir listado de proveedores
        </v-card-title>
        <v-container>
          <v-row class="mx-2">
            <v-file-input v-model="file" accept=".xls, .xlsx" label="Archivo Excel"></v-file-input>
          </v-row>
        </v-container>
        <v-card-actions>
          <v-btn
            @click="upload = false"
          >Cancelar</v-btn>
          <v-btn
            color="primary"
            @click="uploadFacilities"
          >Subir</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- / Modal upload -->
    
    <v-snackbar
      v-model="snackbar"
      :timeout="5000"
      :color="color"
    >
      {{ validation_message }}

      <template v-slot:action="{ attrs }">
        <v-btn
          color="white"
          text
          v-bind="attrs"
          @click="snackbar = false"
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>
<script>
  import {mapState, mapMutations} from 'vuex'

  export default {
    data: () => ({
      errors: [],
      snackbar: false,
      color: 'green',
      validation_message: '',
      search: null,
      file: null,
      dialog: false,
      upload: false,
      companyIndex: -1,
      company: {
        id: 0,
        name: '',
        rut: '',
      },
      companiesListHeaders: [
        {
          text: 'Id',
          align: 'center',
          sortable: true,
          value: 'id',
          class: "salmon black--text elevation-1 elevation-3"
        },
        {
          text: 'Rut Proveedor',
          align: 'left',
          sortable: true,
          value: 'rut',
          class: "salmon black--text elevation-1 elevation-3"
        },
        {
          text: 'Nombre Proveedor',
          align: 'left',
          sortable: true,
          value: 'name',
          class: "salmon black--text elevation-1 elevation-3"
        },
        {
          text: 'Acciones',
          align: 'center',
          sortable: false,
          value: 'actions',
          class: "salmon black--text elevation-1 elevation-3"
        },
      ],
      companiesListBody: [],
    }),
    mounted() {
      this.loadFacilities();
    },
    methods:{
      async loadFacilities(){
        this.mostrarLoading('Cargando listado de proveedores...');
        let url = `${this.base_url}companies`;
        await this.axios.get(url, this.headers).then((response)=>{
            this.companiesListBody = response.data.data;
            this.ocultarLoading();
        }).catch((error)=>{
            console.log(error);
            this.ocultarLoading();
        });
      },
      async saveCompany(){
        // validation
        this.errors = [];
        if(!this.company.name){
          this.errors.push("Debe indicar nombre del proveedor");
        }
        if(!this.company.rut){
          this.errors.push("Debe indicar rut del proveedor");
        }
        if(this.errors.length > 0){
          this.validation_message = this.errors.join();
          this.showSnackBar(true);
          return;
        }
        let url = `${this.base_url}companies`;
        let companyData = {
          'name': this.company.name,
          'rut': this.company.rut,
        };
        let response = null;
        if(this.company.id > 0){
          url = url + "/" + this.company.id;
          try{
            response = await this.axios.put(url, companyData, this.headers);
            let index = this.companiesListBody.map(company => {
              return company.id;
            }).indexOf(this.company.id);
            this.companiesListBody.splice(index, 1, response.data.data);
            this.dialog = false;
            this.showSnackBar(false);
          }catch(error){
            response = error.response;
            let msg = response.data.data;
            this.validation_message = response.status + ': ' + response.data.message + '. '+ msg;
            this.showSnackBar(true);
          }
        }else{
          try{
            response = await this.axios.post(url, companyData, this.headers);
            this.companiesListBody.push(response.data.data);
            this.validation_message = "Grabado exitosamente!";
            this.showSnackBar(false);
          }catch(error){
            response = error.response;
            let msg = response.data.data;
            this.validation_message = response.status + ': ' + response.data.message + '. '+ msg;
            this.showSnackBar(true);
          }
        }
      },
      editCompany(item) {
        this.companyIndex = this.companiesListBody.indexOf(item)
        this.company = Object.assign({}, item)
        this.dialog = true
      },
      deleteCompany(item) {
        this.$confirm('Desea borrar este proveedor?').then(res => {
          if(res){
            let url = `${this.base_url}companies/${item.id}`;
            this.axios.delete(url, this.headers).then((response)=>{
              console.log(response);
              const index = this.companiesListBody.indexOf(item);
              this.companiesListBody.splice(index, 1);
              this.showSnackBar(false);
            }).catch((error)=>{
              console.log(error);
              this.validation_message = "Se produjo un error";
              this.showSnackBar(true);
            });
          }
        });
      },
      closeModal(){
        this.dialog = false;
        this.error = null;
        this.error_message = "";
        this.company.name = "";
      },
      async uploadFacilities(){
        if(!this.file){
          this.validation_message = "Debe seleccionar un archivo Excel";
          this.showSnackBar(true);
          return;
        }
        this.headers.headers['Content-Type'] = "multipart/form-data";
        let url = `${this.base_url}companies/upload`;
        let formData = new FormData();
        formData.append("excel", this.file);
        await this.axios.post(url, formData, this.headers).then((response)=>{
          console.log(response.data.data);
          this.file = null;
          this.upload = false;
          this.showSnackBar(false);
          this.loadFacilities();
        }).catch((response)=>{
          console.log(response);
          this.validation_message = "Formato de archivo no válido";
          this.showSnackBar(true);
        });
      },
      showSnackBar(error){
        if(error){
          this.color = 'red';
        }else{
          this.color = 'green';
          this.validation_message = "Ejecutado exitosamente!";
        }
        this.snackbar = true;
      },
      ...mapMutations(['actualizarBaseUrl', 'mostrarLoading', 'ocultarLoading']),
    },
    computed:{
      ...mapState(['authenticated', 'loading', 'base_url', 'headers']),
    },
    components:{
    }
  }
</script>